import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/vsts/work/1/s/adminportal/node_modules/@ant-design/nextjs-registry/es/AntdRegistry.js");
;
import(/* webpackMode: "eager" */ "/home/vsts/work/1/s/adminportal/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["AppProvider"] */ "/home/vsts/work/1/s/adminportal/src/app/app-provider.tsx");
